

module.exports = __webpack_require__.stylable.create(
    "Price739970206",
    {"classes":{"root":"Price739970206__root","wrapper":"Price739970206__wrapper","currency":"Price739970206__currency","price":"Price739970206__price"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "Price739970206",
    null
);
